// File Metadata:
// Filename: qualityStatus.js
// Version: 1.00
// Created: 2025-03-23 14:27:03
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

export const QUALITY_STATUS = {
    PENDING: {
        value: 'PENDING',
        label: 'Pending',
        color: '#9e9e9e'
    },
    PENDING_APPROVAL: {
        value: 'PENDING_APPROVAL',
        label: 'Pending Approval',
        color: '#ffa726'
    },
    APPROVED: {
        value: 'APPROVED',
        label: 'Approved',
        color: '#66bb6a'
    },
    REJECTED: {
        value: 'REJECTED',
        label: 'Rejected',
        color: '#f44336'
    },
    NEEDS_REVIEW: {
        value: 'NEEDS_REVIEW',
        label: 'Needs Review',
        color: '#29b6f6'
    },
    CONDITIONALLY_APPROVED: {
        value: 'CONDITIONALLY_APPROVED',
        label: 'Conditionally Approved',
        color: '#8d6e63'
    }
}
